// Direct-contact channel helpers for the Public Professional Profile.
// Reuses ONLY the professional's opt-in public mobile (show_public_mobile). No new PII.
// Philippine number normalization: 09XXXXXXXXX / 9XXXXXXXXX / +63XXXXXXXXXX -> 63XXXXXXXXXX.
export function digitsPH(raw) {
  if (!raw) return null;
  let d = String(raw).replace(/\D/g, "");
  if (!d) return null;
  if (d.startsWith("0")) d = "63" + d.slice(1);
  else if (d.length === 10 && d.startsWith("9")) d = "63" + d;
  return d;
}
export function telHref(raw) {
  const d = digitsPH(raw);
  return d ? `tel:+${d}` : null;
}
export function waHref(raw) {
  const d = digitsPH(raw);
  return d ? `https://wa.me/${d}` : null;
}
export function viberHref(raw) {
  const d = digitsPH(raw);
  return d ? `viber://chat?number=%2B${d}` : null;
}
